module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/ola-najdecka-e522234505eb95cb28097fdcc6bb1cd9.png";